
import '@/fonts/fonts.css'
import './app.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store.js'
import { getLang } from './util/lang.js'

import './plugins/element.js'
import i18n from './plugins/i18n.js'

import {
  filterHref,
  bgimgFilter,
  imgFilter,
  filterDay,
  filterMonth,
  dateFilter,
  substrFilter
} from '@/filter/index.js'

// 国际化
// 优先级: localStorage > 浏览器 > default: en
const lang = window.localStorage.getItem('lang') || getLang()
store.commit('setLang', lang)
i18n.locale = lang

Vue.filter('filterHref', filterHref)
Vue.filter('bgimgFilter', bgimgFilter)
Vue.filter('imgFilter', imgFilter)
Vue.filter('filterDay', filterDay)
Vue.filter('filterMonth', filterMonth)
Vue.filter('dateFilter', dateFilter)
Vue.filter('substrFilter', substrFilter)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
